import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "social_medias" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Social = _resolveComponent("Social")!

  return (_openBlock(), _createElementBlock("footer", null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "Mateusz Słotwiński", -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.socialMedia, (media) => {
            return (_openBlock(), _createBlock(_component_Social, {
              key: media,
              media: media
            }, null, 8, ["media"]))
          }), 128))
        ])
      ])
    ])
  ]))
}